module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_9006.734cd9c7.png";